export default __webpack_public_path__ + "static/media/three.6f219f33.png";